var _style, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31 31",
    style: {
      enableBackground: "new 0 0 31 31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#122947;stroke-miterlimit:10;}\n\t.st1{fill:#122947;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 15.5,
    cy: 15.5,
    r: 14.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.9,6c-0.2-0.2-0.5-0.3-0.8-0.3H7c-0.7,0-1.2,0.5-1.2,1.2v16.9c0,0.8,0.5,1.3,1.2,1.3h16.9 c0.7,0,1.3-0.6,1.3-1.3v-14c0-0.3-0.1-0.6-0.3-0.8L21.9,6z M8.4,6.3h10.5v5.2c0,0.2-0.1,0.3-0.3,0.3H8.7c-0.2,0-0.3-0.1-0.3-0.3 C8.4,11.6,8.4,6.3,8.4,6.3z M19.5,24.6H7.7v-6.8c0-0.1,0.1-0.2,0.3-0.2h11.1c0.2,0,0.3,0.1,0.3,0.2v6.8H19.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.4,11.2L17.4,11.2c-0.3,0-0.5-0.2-0.5-0.5V7.3c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v3.4 C17.9,10.9,17.6,11.2,17.4,11.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.7ab188075904710e493659b82ee5044d.svg";
export { ForwardRef as ReactComponent };